export default "<p>\n  loading works!\n</p>\n"